<template>
  <div class="book">
    <!-- <book-test/> -->
    <read-book/>
    <!-- The Book -->
    <page-navigation/>
    <word-lookup-modal-v2 v-if="showModal"/>
    <!-- <word-lookup-modal-v2 v-if="showModal && getHasPagesDicInStore"/> -->
    <!-- <word-lookup-modal v-if="showModal && !getHasPagesDicInStore"/> -->
  </div>
</template>

<script>
// import bookTest from '@/components/bookTest.vue'
import readBook from '@/components/readBook.vue'
import pageNavigation from '@/components/pageNavigation.vue'
import wordLookupModal from '@/components/wordLookupModal.vue'
import wordLookupModalV2 from '@/components/wordLookupModalV2.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'Book',
    data (){
      return {
      }
    },
  components: {
    // bookTest,
    wordLookupModal,
    wordLookupModalV2,
    pageNavigation,
    readBook
  },
  methods: {
  },
  computed: {
  ...mapGetters([
    'getHasPagesDicInStore'
    ]),
    showModal() {
      return this.$store.getters.showLookupModal
    }
  }
}
</script>

<style scoped>
.book {
  margin-bottom: 150px;
}
</style>
